// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Scalars = require("../../../scalars/Scalars.bs.js");
var UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
var DateFns = require("date-fns");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Link = require("next/link").default;
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var SharedPostEmailStatsButton = require("./SharedPostEmailStatsButton.bs.js");
var MySharedPostsWidgetListItemSharedProperty_sharedProperty_graphql = require("../../../__generated__/MySharedPostsWidgetListItemSharedProperty_sharedProperty_graphql.bs.js");

var convertFragment = MySharedPostsWidgetListItemSharedProperty_sharedProperty_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MySharedPostsWidgetListItemSharedProperty_sharedProperty_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MySharedPostsWidgetListItemSharedProperty_sharedProperty_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MySharedPostsWidgetListItemSharedProperty_sharedProperty_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MySharedPostsWidgetListItemSharedProperty_sharedProperty_graphql.node, convertFragment, fRef);
}

var SharedPropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MySharedPostsWidgetListItemSharedProperty(props) {
  var sharedProperty = use(props.sharedProperty);
  var match = React.useState(function () {
        return false;
      });
  var setIsExpanded = match[1];
  var isExpanded = match[0];
  var match$1 = sharedProperty.contacts;
  var contacts;
  if (match$1 !== undefined) {
    var edges = match$1.edges;
    contacts = edges !== undefined ? Core__Array.keepSome(Core__Array.keepSome(edges).map(function (c) {
                return c.node;
              })) : [];
  } else {
    contacts = [];
  }
  var firstContact = Core__Array.findMap(contacts, (function (c) {
          switch (c.__typename) {
            case "SharingContactClientContactV5" :
                return c;
            case "SharingContactFreshContactV5" :
            case "__unselected" :
                return contacts[0];
            
          }
        }));
  var contactToDisplayString = function (c) {
    switch (c.__typename) {
      case "SharingContactClientContactV5" :
          var lastName = c.lastName;
          var firstName = c.firstName;
          if (lastName !== undefined) {
            return firstName + " " + lastName;
          } else {
            return firstName;
          }
      case "SharingContactFreshContactV5" :
          return Scalars.EmailAddress.toString(c.email);
      case "__unselected" :
          return "";
      
    }
  };
  var otherContacts = contacts.filter(function (c) {
        if (firstContact === undefined) {
          return true;
        }
        switch (firstContact.__typename) {
          case "SharingContactClientContactV5" :
              switch (c.__typename) {
                case "SharingContactClientContactV5" :
                    return firstContact.databaseId !== c.databaseId;
                case "SharingContactFreshContactV5" :
                case "__unselected" :
                    return true;
                
              }
          case "SharingContactFreshContactV5" :
              switch (c.__typename) {
                case "SharingContactFreshContactV5" :
                    return firstContact.databaseId !== c.databaseId;
                case "SharingContactClientContactV5" :
                case "__unselected" :
                    return true;
                
              }
          case "__unselected" :
              return true;
          
        }
      });
  var match$2 = sharedProperty.propertyLocation;
  var tmp;
  if (match$2 !== undefined) {
    switch (match$2.__typename) {
      case "PropertyLocationWithHiddenAddress" :
          tmp = "Hidden Address, " + match$2.locationDisplay;
          break;
      case "PropertyLocationWithVisibleAddress" :
          tmp = match$2.address + ", " + match$2.locationDisplay;
          break;
      case "__unselected" :
          tmp = null;
          break;
      
    }
  } else {
    tmp = null;
  }
  var tmp$1;
  if (isExpanded) {
    var len = otherContacts.length;
    var tmp$2;
    if (len !== 1) {
      tmp$2 = len !== 0 ? JsxRuntime.jsx("div", {
              children: otherContacts.map(function (c, index) {
                    return JsxRuntime.jsxs("span", {
                                children: [
                                  index !== 0 ? (
                                      index !== 1 ? ", " : "and "
                                    ) : null,
                                  contactToDisplayString(c)
                                ]
                              });
                  }),
              className: "flex flex-row space-x-1 text-gray-500"
            }) : null;
    } else {
      var singleContact = otherContacts[0];
      tmp$2 = contactToDisplayString(singleContact);
    }
    tmp$1 = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
                children: tmp$2,
                className: ""
              }),
          className: "col-span-12"
        });
  } else {
    tmp$1 = null;
  }
  var match$3 = sharedProperty.property;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Link, {
                                      href: "/shared-property/" + sharedProperty.databaseId,
                                      className: "font-semibold",
                                      children: Caml_option.some(tmp)
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: "Shared with " + Core__Option.getOr(Core__Option.map(firstContact, (function (c) {
                                                  return contactToDisplayString(c);
                                                })), "-") + (
                                        otherContacts.length !== 0 ? " and " : ""
                                      ),
                                      className: "text-gray-500 mt-1"
                                    }),
                                otherContacts.length !== 0 ? JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
                                              onClick: (function (param) {
                                                  setIsExpanded(function (currentState) {
                                                        return !currentState;
                                                      });
                                                }),
                                              children: Caml_option.some(JsxRuntime.jsxs("div", {
                                                        children: [
                                                          otherContacts.length !== 1 ? otherContacts.length.toString() + " other contacts" : " 1 other contact",
                                                          JsxRuntime.jsx("span", {
                                                                children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                                                      icon: isExpanded ? "ArrowUp" : "ArrowDown",
                                                                      size: 10
                                                                    }),
                                                                className: "inline-flex pl-2"
                                                              })
                                                        ]
                                                      }))
                                            }),
                                        className: "mt-2"
                                      }) : null,
                                tmp$1
                              ]
                            }),
                        JsxRuntime.jsx("div", {
                              children: Core__Option.getOr(Core__Option.map(sharedProperty.createdAt, (function (v) {
                                          return DateFns.format(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(v)), "MM/dd/yyyy");
                                        })), ""),
                              className: "mt-2 md:mt-0"
                            })
                      ],
                      className: "col-span-12 lg:col-span-6 flex flex-col md:flex-row md:justify-between md:items-center"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        match$3 !== undefined ? JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                href: "/properties/" + match$3.id,
                                size: "small",
                                children: "View Property"
                              }) : null,
                        JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                              href: "/shared-property/" + sharedProperty.databaseId,
                              size: "small",
                              children: "View Shared Post"
                            }),
                        JsxRuntime.jsx(SharedPostEmailStatsButton.make, {
                              sharedMessageId: sharedProperty.databaseId
                            })
                      ],
                      className: "col-span-12 lg:col-span-6 text-right flex flex-row space-x-2 md:justify-end items-center pt-2 md:pt-0"
                    })
              ],
              className: "grid grid-cols-12 gap-2 py-4 border-t"
            });
}

var make = MySharedPostsWidgetListItemSharedProperty;

exports.SharedPropertyFragment = SharedPropertyFragment;
exports.make = make;
/* react Not a pure module */
